var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "fileupload" } },
    [
      _vm.overallDescription
        ? _c("form", { attrs: { id: "attachment-desc-form" } }, [
            _c("textarea", {
              directives: [
                { name: "autosize", rawName: "v-autosize" },
                { name: "hkldinput", rawName: "v-hkldinput" },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.attachment.description,
                  expression: "attachment.description",
                },
              ],
              staticClass: "autosize ",
              attrs: { type: "text" },
              domProps: { value: _vm.attachment.description },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.attachment, "description", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "fileupload-desc-hint" },
              [
                _c("popover", {
                  attrs: {
                    text: _vm.$t("tender.attachment.descriptionPlaceholder"),
                    position: "bottom-left",
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.readonly
        ? _c("HkldDropzone", {
            ref: "hkldDropzone",
            attrs: {
              sourceId: _vm.resourceId || "",
              metaData: _vm.metaData,
              uploadDocTypes: _vm.uploadDocTypes,
              maxNumberOfFiles: _vm.maxNumberOfFiles,
              maxTotalFileSizeInBytes: _vm.maxTotalFileSizeInBytes,
              existingFiles: _vm.attachment.files,
              uploadNoteRows: _vm.uploadNoteRows,
              filesExceedMessage: _vm.filesExceedMessage,
              totalSizeExceedMessage: _vm.totalSizeExceedMessage,
              useTotalSizeMessageForFileSizeError:
                _vm.useTotalSizeMessageForFileSizeError,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showTenderHints
        ? _c("p", { staticClass: "hint" }, [
            _vm._v(_vm._s(_vm.$t("tender.attachment.attachmentNotes"))),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "table",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.attachment.files.length > 0,
              expression: "attachment.files.length>0",
            },
          ],
          staticClass: "tender-tnc-table",
        },
        [
          _c("thead", [
            _c("th", { staticClass: "number tender-font" }, [_vm._v("#")]),
            _vm._v(" "),
            _c("th", { staticClass: "filename tender-font" }, [
              _vm._v(_vm._s(_vm.$t("tender.attachment.document"))),
            ]),
            _vm._v(" "),
            _c("th", { staticClass: "description tender-font" }, [
              _vm._v(_vm._s(_vm.$t("tender.attachment.description"))),
            ]),
            _vm._v(" "),
            _c("th"),
          ]),
          _vm._v(" "),
          _c(
            "draggable",
            {
              attrs: { options: { handle: ".myHandler" }, element: "tbody" },
              on: { end: _vm.onDraggableEnd },
              model: {
                value: _vm.files,
                callback: function ($$v) {
                  _vm.files = $$v
                },
                expression: "files",
              },
            },
            [
              _vm._l(_vm.files, function (item, index) {
                return [
                  _c("tr", { key: index, staticClass: "set-border-top" }, [
                    _c("td", { staticClass: "number tender-font myHandler" }, [
                      _vm._v(_vm._s(index + 1)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "filename tender-font myHandler" },
                      [
                        _c(
                          "a",
                          {
                            staticStyle: { "text-decoration": "underline" },
                            on: {
                              click: function ($event) {
                                return _vm.downloadFile(item.id)
                              },
                            },
                          },
                          [_vm._v(_vm._s(item.filename))]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("td", { staticClass: "description tender-font" }, [
                      _c("textarea", {
                        directives: [
                          {
                            name: "file-description-value",
                            rawName: "v-file-description-value",
                            value: item.description,
                            expression: "item.description",
                          },
                          {
                            name: "autosize",
                            rawName: "v-autosize",
                            value: { defer: true },
                            expression: "{defer: true}",
                          },
                        ],
                        staticClass: "file-upload-desc autosize",
                        class: {
                          "error-highlight":
                            _vm.invalidDescriptionLength &&
                            item.description.length > _vm.maxDescriptionLength,
                        },
                        attrs: {
                          disabled: _vm.readonly,
                          maxlength: _vm.maxDescriptionLength,
                        },
                        on: {
                          input: function (event) {
                            return _vm.updateDescriptionDraft(
                              item,
                              event.target.value
                            )
                          },
                          change: function (event) {
                            return _vm.commitDescription(
                              item,
                              event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      !_vm.readonly
                        ? _c(
                            "div",
                            {
                              staticClass: "file-upload-delete",
                              on: {
                                click: function ($event) {
                                  return _vm.deleteFile(index, item)
                                },
                              },
                            },
                            [_vm._v("✕")]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }